"use client";
//#region packages/@mantine/core/src/components/ModalBase/ModalBase.module.css
var ModalBase_module_default = {
	"title": "m_615af6c9",
	"header": "m_b5489c3c",
	"inner": "m_60c222c7",
	"content": "m_fd1ab0aa",
	"close": "m_606cb269",
	"body": "m_5df29311"
};
//#endregion
export { ModalBase_module_default as default };

//# sourceMappingURL=ModalBase.module.mjs.map